import { getCustomisationValue, updateCustomisationValue } from "../../../EditablePreview/EditablePreview";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";
import { changeNumericalFieldValue } from "../../ModuleList";

const DimensionsModule = (props) => {
    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;

    const visualisationComponentKey = props.visualisationComponentKey || null;
    const index = props.index ?? 0;

    let dimensionsFieldConfig = null;
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const field = moduleConfig.fields[i];
        if (field.field.includes('dimensions-dimensions')) {
            dimensionsFieldConfig = field;
        }
    }

    const changeDimensionsFieldValue = (field, value) => {
        if (dimensionsFieldConfig?.[field]) {
            if (changeNumericalFieldValue(customisationVars, dimensionsFieldConfig[field], value, true, index, visualisationComponentKey, props.selectedFeatureNode)) {
                props?.forceUpdateComponent?.();
            }
        }
    }

    return (
        <div className="v2-basic-module-holder">
            <h5>Dimensions</h5>

            {renderFirstCustomBlock(props)}

            <div className='v2-module-one-column'>
                <div className='v2-module-field-label'>Dimensions</div>
                <div className='v2-module-columns-holder'>
                    <div className='v2-module-one-column'>
                        <ModuleNumericalInput
                            fieldLabel="W"
                            value={getCustomisationValue(customisationVars, dimensionsFieldConfig?.["dimensions-width"]?.dataLink, index, visualisationComponentKey, props.selectedFeatureNode) ?? '-'}
                            fieldId={dimensionsFieldConfig?.["dimensions-width"]?.dataLink}
                            enabled={!!dimensionsFieldConfig?.["dimensions-width"]?.dataLink}
                            onChange={(fieldId, value) => changeDimensionsFieldValue("dimensions-width", value)}
                        />
                    </div>
                    <div className='v2-module-one-column'>
                        <ModuleNumericalInput
                            fieldLabel="H"
                            value={getCustomisationValue(customisationVars, dimensionsFieldConfig?.["dimensions-height"]?.dataLink, index, visualisationComponentKey, props.selectedFeatureNode) ?? '-'}
                            fieldId={dimensionsFieldConfig?.["dimensions-height"]?.dataLink}
                            enabled={!!dimensionsFieldConfig?.["dimensions-height"]?.dataLink}
                            onChange={(fieldId, value) => changeDimensionsFieldValue("dimensions-height", value)}
                        />
                    </div>
                </div>
            </div>

            {renderSecondCustomBlock(props)}

        </div>
    );
}

export default DimensionsModule;
